/*
**************************** 
홈페이지 비번찾기 결과 및 변경
*****************************
*/

import { useEffect, useState } from "react";
import NewPassword from "./NewPassword";

export default function FindResultEndPass(props) {
    const [loginIdArr, setLoginIdArr] = useState([]);
    const [changeData, setChangeData] = useState({});

    useEffect(() => {
        let copyData = [...loginIdArr];
        copyData = props.loginIdArrData;
        setLoginIdArr(copyData);

        return () => {
            resetFunc();
        };
    }, [props.loginIdArrData])

    const resetFunc = function () {
        let copyData = [...loginIdArr];

        copyData = [];
        setLoginIdArr(copyData);
    };

    const setFunc = (changeData) => {
        let copyChangeData = { ...changeData };
        copyChangeData = changeData;
        setChangeData(copyChangeData);
    };

    return (
        <div>
            <div>
                <div className="modal fade" id="findResultEndPass" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">비밀번호 찾기</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                }}></button>
                            </div>
                            <div className="modal-body">
                                <div className="sign-up">
                                    <form  >
                                        <div className="form-group text-start">
                                            <label className="form-label mt-4 fw-bolder fs-6">비밀번호 변경 후 로그인 하세요</label>
                                        </div>
                                        <div className="form-group text-start">
                                            {/* <label className="form-label small">비밀번호 변경 후 로그인 하세요</label> */}
                                        </div>
                                        {loginIdArr.map((cell, idx) => {
                                            return (
                                                <div className="row" key={idx}>
                                                    <div className="col form-group text-start">
                                                        <label className="form-label mt-2 small">{cell.login_id}</label>
                                                    </div>
                                                    <div className="col form-group text-end">
                                                        <button type="button" className="btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#newPassword" onClick={() => {
                                                            const changeData = { id: cell.id, login_id: cell.login_id };
                                                            setFunc(changeData);
                                                        }}>비밀번호 변경</button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <div className="form-group mt-2 row p-2">
                                            <button type="button" className="btn btn-lg btn-primary mt-3" data-bs-toggle="modal" data-bs-target="#exampleModal">로그인하기</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <NewPassword changeData={changeData}></NewPassword>
        </div>
    )
} 